<template>
	<div class="flex items-center">
		<Transition v-bind="buttonTransition">
			<template v-if="isCopyIconClicked">
				<IconMaterialSymbolsLightCheck
					:class="cn('cursor-pointer text-primary', props.iconClass)"
				/>
			</template>

			<template v-else>
				<TooltipButton
					tooltip-text="Copiar"
					variant="primary"
					:show-tooltip="isCopyIconHovered"
				>
					<IconMaterialSymbolsLightContentCopyOutline
						ref="iconRef"
						:class="
							cn(props.iconClass, 'cursor-pointer text-sm text-primary-light-1')
						"
						@click="handleClickCopy"
					/>
				</TooltipButton>
			</template>
		</Transition>
	</div>
</template>

<script setup lang="tsx">
import { useElementHover } from '@vueuse/core';
import { cn } from '~/utils';
import { isMobileDevice } from '~~/utils';

import { TooltipButton } from '../ui/tooltip-button/index';

const props = withDefaults(
	defineProps<{
		iconClass?: string;
	}>(),
	{
		iconClass: 'ml-1'
	}
);

const opacityStartClass = 'opacity-0';
const opacityEndClass = 'opacity-100';
const transitionDefaultClass = 'transition-opacity duration-300 ease-in';
const buttonTransition = {
	enterActiveClass: transitionDefaultClass,
	enterFromClass: opacityStartClass,
	enterToClass: opacityEndClass
};

const iconRef = ref<HTMLElement | null>();
const isCopyIconClicked = ref(false);
const isCopyIconHovered = ref(false);
const emit = defineEmits<{
	(e: 'click-copy'): void;
}>();

onMounted(() => {
	if (!isMobileDevice(window?.navigator?.userAgent)) {
		const hoverRef = useElementHover(iconRef);

		watch(hoverRef, newVal => {
			isCopyIconHovered.value = newVal;
		});
	}
});

watch(iconRef, newRef => {
	if (!newRef) {
		clearHoverTooltip();
	}
});

function clearHoverTooltip() {
	isCopyIconHovered.value = false;
}

function handleClickCopy() {
	isCopyIconClicked.value = true;
	emit('click-copy');
	setTimeout(() => {
		isCopyIconClicked.value = false;
	}, 2500);
}
</script>
